<div class="visualization-tile">
  <div class="tile-header">
    <div class="tile-header-title">{{graphTitle}}</div>
  </div>
  <div class="tile-content">
    <div class="riskmap-chart">
      <canvas #myCanvas baseChart
        [datasets]="barChartData"
        [labels]="barChartLabels"
        [options]="barChartOptions"
        [legend]="barChartLegend"
        [colors]="barChartColors"
        [chartType]="barChartType">
      </canvas>
    </div>
  </div>
</div>